import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiV2 } from "../../apiV2";
import { memberQueryKeys } from "./memberQueryKeys";

export function useMutationRemovePromotionCodeFromSubscription({
  api,
}: {
  api: ApiType;
}) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ subscriptionId }: { subscriptionId: number }) =>
      api.memberApi.removePromotionCodeFromSubscription({
        subscriptionId,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: memberQueryKeys.all() });
      queryClient.invalidateQueries({
        queryKey: apiV2.staff.subscription.keys.all(),
      });
    },
  });
}
